import React, {useState} from "react";
import {
  useNavigate,
  Link
} from 'react-router-dom';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';



import OpenDiscoverMyRolePC from './OpenDiscoverMyRolePC';
import OpenDiscoverMyRoleMobile from './OpenDiscoverMyRoleMobile';
import OpenDiscoverMyRoleTablet from './OpenDiscoverMyRoleTablet';



const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function OpenDiscoverMyRole(props) {

   const quitDiscoverMyRole = () => {
     props.quitDiscoverMyRole();
   }

   const joinCreativeArmy = () => {
     props.joinCreativeArmy();
   }

    return (

        <div style={{width: viewportWidth+'px'}}>

              {!isMobileOnly && !isTablet &&
                <BrowserView>
                  <OpenDiscoverMyRolePC quitDiscoverMyRole={quitDiscoverMyRole} joinCreativeArmy={joinCreativeArmy}/>
               </BrowserView>
             }

              {isMobileOnly &&
        			  <MobileView>
        	         <OpenDiscoverMyRoleMobile quitDiscoverMyRole={quitDiscoverMyRole} joinCreativeArmy={joinCreativeArmy}/>
        			 </MobileView>
        			}

        			{isTablet &&
        			  <TabletView>
        			     <OpenDiscoverMyRoleTablet quitDiscoverMyRole={quitDiscoverMyRole} joinCreativeArmy={joinCreativeArmy}/>
        			  </TabletView>
        			}

        </div>

    );




}
